.xm-scope-lock {
  cursor: not-allowed;
  opacity: 0.35;
}

.xm-scope-lock-wrap {
  display: inline-flex;
  cursor: not-allowed;
}

// Specificity must match antd's own cell rule, so that its stronger :hover still wins
.ant-table-tbody > tr.xm-scope-locked-row > td {
  background-color: rgba(0, 0, 0, 0.02);
  color: rgba(0, 0, 0, 0.65);
}

[data-theme="dark"] .ant-table-tbody > tr.xm-scope-locked-row > td {
  background-color: rgba(255, 255, 255, 0.03);
  color: rgba(255, 255, 255, 0.65);
}
